import { createTheme, responsiveFontSizes, ThemeOptions } from '@mui/material';
import { getCobrandWithDefault } from 'features/cobrand/utils/cobrandUtils';
import { CobrandIdentifier } from 'features/cobrand/types';
import {
  wellframeLightTheme,
  hphcLightTheme,
  bcbsKansasCityLightTheme,
  bcbsSouthCarolinaLightTheme,
  hscsnLightTheme,
  bcbsTennesseeLightTheme,
  careFirstLightTheme,
  careElevateLightTheme,
} from '../themes';
import { APP_LIGHT_MODE } from '../constants';

const cobrandThemes = new Map<string, ThemeOptions>([
  ['wellframelight', wellframeLightTheme],
  [`${CobrandIdentifier.HARVARD_PILGRIM}light`, hphcLightTheme],
  [`${CobrandIdentifier.BCBS_KANSAS_CITY}light`, bcbsKansasCityLightTheme],
  [`${CobrandIdentifier.BCBS_SOUTH_CAROLINA}light`, bcbsSouthCarolinaLightTheme],
  [`${CobrandIdentifier.BCBS_TENNESSEE}light`, bcbsTennesseeLightTheme],
  [`${CobrandIdentifier.HSCSN}light`, hscsnLightTheme],
  [`${CobrandIdentifier.CARE_FIRST}light`, careFirstLightTheme],
  [`${CobrandIdentifier.CARE_ELEVATE}light`, careElevateLightTheme],
]);

/**
 * Creates a theme with responsive font sizing applied.
 * @param themeOptions - MUI theme options
 * @returns Theme with responsive font sizes
 */
export const createThemeWithResponsiveFontSize = (themeOptions: ThemeOptions) =>
  responsiveFontSizes(createTheme(themeOptions));

/**
 * Determines the initial theme based on current cobrand detection.
 * Uses unified resolution to detect cobrand from hostname or path.
 * Defaults to Wellframe light theme if cobrand theme not found.
 * @returns Theme object ready for use
 */
export const getInitialTheme = () => {
  // Use unified resolution to get current cobrand (hostname > path > default)
  const cobrandName = getCobrandWithDefault();

  // Construct lookup key with light mode (default color mode)
  const initialTheme = cobrandThemes.get(`${cobrandName}${APP_LIGHT_MODE}`);

  if (initialTheme) {
    return createThemeWithResponsiveFontSize(initialTheme);
  }

  // Fallback to Wellframe light theme
  return createThemeWithResponsiveFontSize(wellframeLightTheme);
};

// Export cobrandThemes for use in ThemeContext
export { cobrandThemes };
